export const fields = [
  {
    name: 'name',
    label: 'externalStorage.name',
    description: 'name',
    type: 'TEXT',
    mandatory: true
  },
  {
    name: 'ftpType',
    label: 'externalStorage.ftpType',
    description: 'ftpType',
    type: 'PICKLIST',
    mandatory: true
  },
  {
    name: 'ftpHost',
    label: 'externalStorage.ftpHost',
    description: 'ftpHost',
    type: 'TEXT',
    mandatory: false
  },
  {
    name: 'ftpPort',
    label: 'externalStorage.ftpPort',
    description: 'ftpPort',
    type: 'INTEGER',
    mandatory: true
  },
  {
    name: 'ftpUser',
    label: 'externalStorage.ftpUser',
    description: 'ftpUser',
    type: 'TEXT',
    mandatory: true
  }
];
